import { ComunicacaoService } from './shared/services/comunicacao.service';
import { UserSession } from './shared/models/user-session.model';
import { environment } from './../environments/environment';
import { SessionService } from './shared/services/session.service';
import { Component, ChangeDetectorRef, OnInit, HostListener } from '@angular/core';
import { Subject, observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { EntrySelect } from './shared/models/EntrySelect.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RestService } from './shared/services/rest.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SelecionarEmpresaPerfilComponent } from './pages/selecionar-empresa-perfil/selecionar-empresa-perfil.component';
import { MessageService } from './shared/message.service';
import { Message, WebSocketService } from './shared/services/web-socket.service';
import { WebSocketContent, _connect, _desconnect } from './shared/models/webSocketContent';
import { WebSocketChatService } from './shared/services/web-socket-chat.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    this.socket.messages.complete();
    this.session.isLogado.unsubscribe();
    this.socket.connectionStats.unsubscribe();
    this.monitoramentoErro.complete();
    this.interacaoChamado.complete();
    this.protocoloChamado.complete();
    this.monitoramentoConexaoWebSocket.complete();
    this.notificacao.complete();
    this._reconnect.complete();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth > 768) {
      this.navBarLateral = true;
    } else
      this.navBarLateral = false;

  }
  public logado: Subject<boolean> = this.session.isLogado;
  //listEmpresa: Subject<Array<EntrySelect>> = this.rest.empresas;
  resourceForm: FormGroup;
  bsModalRef: BsModalRef;
  currentEmpresaPerfil: any;
  width: string = "10";
  title = 'orcamentacao-client';
  menu_visible = true;
  //session
  sessao: UserSession;
  sideBar: boolean = true;
  _reconnect: Subject<any>;
  notificacao: Subject<any>;
  interacaoChamado: Subject<any>;
  protocoloChamado: Subject<any>;
  monitoramentoErro: Subject<any>;
  monitoramentoConexaoWebSocket: Subject<any>;
  listaMonitoramento: Array<any> = [];
  uuidUser: string;
  reconectTry: number = 0;
  secretKey: string = null;
  ultimaMensagem: WebSocketContent = null;
  isCiclo: boolean;
  loginSiga:boolean = false;
  navBarLateral: boolean = true;// true caso a sidenav bar seja a lateral e false caso seja a superior
  constructor(private session: SessionService,
    private router: Router,
    private formBuilder: FormBuilder,
    private ref: ChangeDetectorRef,
    private rest: RestService,
    private comu: ComunicacaoService,
    private modalService: BsModalService,
    private socket: WebSocketService,
    private sChat: WebSocketChatService
  ) {
    //this.session.getUserSession();
    this.width = this.logado ? "10" : "12";

    //this.rest.loadListEmpresas();

    //validators  
    this.resourceForm = this.formBuilder.group({
      currentEmpresa: [JSON.stringify(this.session.getCurrentEmpresa()), []]
    });

    this.sessao = this.session.getUserSession();
    this.loginSiga = this.sessao.tokenSiga?.length>0;
    this.currentEmpresaPerfil = this.session.getCurrentEmpresa();

    //atualiza current empresa no combo ao modificar o serviço subject.next()
    this.session.getSessionSubject().subscribe(
      data => {
        this.sessao = data;
        this.loginSiga = this.sessao.tokenSiga?.length>0;
        this.currentEmpresaPerfil = data.currentEmpresa;
      });
    this.comu.listen().subscribe((m: any) => {
      if (m == 'printModeON') {
        $('#nav-b').addClass('hide');
      }
      else if (m == 'printModeOFF') {
        $('#nav-b').removeClass('hide');
      }
      else if (m == 'reconnect') {
        if (this.reconectTry <= 5) {
          this.reconectTry++;
          this.reconectWebSocket();
        } else {
          let i = setInterval(() => {
            this.reconectTry == 0;
            this.rest.obterUrlWebSocket().subscribe((data: any) => {
              if (data.status == 'success' && data.url) {
                this.session.setUrlWebSocket(data.url);
                this.reconectWebSocket(data.url);
                this.reconectTry++;
                clearInterval(i);
              }
            });
          }, 30000);
          this.reconectTry == 0;
          this.rest.obterUrlWebSocket().subscribe((data: any) => {
            if (data.status == 'success' && data.url) {
              this.session.setUrlWebSocket(data.url);
              this.reconectWebSocket(data.url);
              this.reconectTry++;
              clearInterval(i);
            }
          });
        }
      }
      else if (m == 're-connected') this._reconnect.next('reconnected');
    });
    if (this.session.isAuthenticated()) {
      if (this.session.obterUrlWebSocket()) {
        this.conectarWebSocket();
      } else {
        this.verificarUrlWebSocket();
      }
      if (this.session.getCurrentChaveCrypto() == null) {
        this.atualizarChaveCriptografiaSocket();
      }
    }
    if (this.session.isAuthenticated()) {
      this.uuidUser = this.session.getUUIDUsuario();
      this.secretKey = this.session.getCurrentSecretKeyEmpresa();
    }
    this.interacaoChamado = new Subject();
    this.protocoloChamado = new Subject();
    this.notificacao = new Subject();
    this._reconnect = new Subject();
    this.monitoramentoConexaoWebSocket = new Subject();
    this.monitoramentoErro = new Subject();
    this.isCiclo = this.session.isCiclo();

    if (window.innerWidth > 768) {
      this.navBarLateral = true;
      this.comu.filter('show-bar');
    } else
      this.navBarLateral = false;
  }

  forceReconnect() {
    this.rest.obterUrlWebSocket().subscribe((data: any) => {
      if (data.status == 'success' && data.url) {
        this.session.setUrlWebSocket(data.url);
        this.reconectWebSocket(data.url);
      }
    });
  }

  habilitarNotificacao(): boolean {
    return this.session.isAuthenticated();
  }

  atualizarChaveCriptografiaSocket() {
    this.rest.obterChaveCrypto().subscribe((data: any) => {
      if (data.status == 'success') {
        this.socket.chave.next(data.data);
        this.sChat.chave.next(data.data);
      }
    });
  }

  conectarWebSocket(byLogin: boolean = false) {
    this.socket.webSocketConnect(this.session.obterUrlWebSocket());
    this.monitorarSocket();
    this.session.isLogado.subscribe((d: boolean) => { if (!d) this.unsubscribeSocket() });
    this.socket.connectionStats.subscribe((stats: boolean) => {
      if (stats) {
        this.monitoramentoConexaoWebSocket.next(_connect);
      } else {
        this.monitoramentoConexaoWebSocket.next(_desconnect);
      }
    });
    if (byLogin) this.socket.chave.next(String(this.session.getCurrentChaveCrypto()));
  }

  reconectWebSocket(url: string = null) {
    this.socket.webSocketReconnect(url ? url : this.session.obterUrlWebSocket());
    this.monitorarSocket();
  }

  unsubscribeSocket() {
    if(this.socket.isConnected){
      this.socket.messages.complete();
      this.socket.messages.unsubscribe();
      this.socket.disconect();
    }
  }

  monitorarSocket() {
    this.socket.messages.subscribe((m: any) => {
      //sempre que uma mensagen é recebida no webSocket ela passa por um filtro para saber se a mensagem é destinada para este
      //usuário ou não, a função receberMsgSocket é usada para realizar esse filtro
      let msg: WebSocketContent = m as WebSocketContent;
      if (this.receberMsgSocket(msg)) {
        if (this.interacaoChamado.observers.length > 0 && (msg.code == 20 || msg.code == 24 || msg.code == 25 || msg.code == 26 || msg.code == 27 || msg.code == 28)) {
          this.interacaoChamado.next(msg);
          if (msg.code == 27 && msg.content == 'Atendimento Ciclo' && this.isCiclo && this.session.isAuthenticated()) {
            this.notificacao.next(msg);
          }
        }
        else if (msg.code == 21 || msg.code == 23) {
          this.protocoloChamado.next(msg);
        }
        else if ((msg.code == 13 || msg.code == 14 || (msg.code == 27 && msg.content == 'Atendimento Ciclo' && this.isCiclo)) && this.session.isAuthenticated()) {
          this.notificacao.next(msg);
        }
        else if (msg.code == 500) {
          this.monitoramentoErro.next(msg);
        }
        else if (msg.code == 1 || msg.code == 2) {
          this.atualizarChaveCriptografiaSocket();
        }
      }
    });
  }

  receberMsgSocket(msg: WebSocketContent): boolean {
    if (msg == null) return false;//caso a mensagem seja nula ela é ignorada
    if (msg.type_recipient == 'server') return false;//caso seja uma mensagem destinada ao servidor ela é ignorada
    if (msg.type_recipient == 'general') return true;//caso seja uma mensagem geral ela é recebida
    if (msg.type_recipient == 'directional' && msg.recipient == this.uuidUser) return true;//caso a mensagem seja direcional e o receptor seja com uuid igual ao
    //do usuário a mensagem é recebida, caso contrario ela é ignorada
    if (msg.type_recipient == 'suport_chamado' && msg.sender.uuid != this.uuidUser) return true;//caso a mensagem seja de suporte e o uuid do usuário que a enviou
    //seja diferente do uuid do usuário que a enviou ela é recebida
    if (msg.type_recipient == 'suport_diretcional' && msg.recipient == this.uuidUser) return true;//caso o suporte seja direcional e 
    //o uuid do usuário receptor seja igual ao uuid do usuário em questão a mensagem é recebida 
    //essa essa função é para uso futuro no qual um chat possa ser implementado no sistema
    if (msg.type_recipient == 'company' && msg.recipient == this.secretKey) return true;//caso a mensagem seja direcionada para uma empresa
    //e o secretkey da empresa seja igual a mensagem é recebida
    if (msg.type_recipient == 'self' && msg.recipient == this.uuidUser) return true;//caso a mensagem seja para outras instancias do mesmo usuário
    //e o uuid do usuário seja igual a mensagem é recebida, essa função pode ser usada para evitar ações duplicadas
    if (msg.type_recipient == 'erro_monitoring' && this.listaMonitoramento.indexOf(msg.recipient) != -1) return true;//caso seja um erro de chamada de API
    //e o código da chamada esteja na lista de monitoramento a mensagem é recebida
    if (msg.type_recipient == 'notification') {//as comparações abaixo são para as mensagens reservadas para notificações
      if (typeof (msg.recipient) == "string") {
        if (msg.recipient == 'All') return true;
        if (msg.recipient == this.uuidUser) return true;
        if (msg.recipient.includes(this.uuidUser)) return true;
      } else if (typeof (msg.recipient) == "object") {
        if (msg.recipient.indexOf(this.uuidUser) != -1) return true;
      }
    }
    return false;
  }

  enviarSocket(json: WebSocketContent) {//essa função realiza o envio de mensagens no WebSocket
    //a função também tem prevensão de erros, caso o Socket esteja desconectado a ultima mensagem é armanezada e disparada em seguida
    //caso o Socket comece a apresentar muitos erros de dispararo devido a desconexões, pode ser alterado para uma lista
    //fazendo assim um buffer para as mensagens não se perderem
    this.ultimaMensagem = json;
    if (this.socket.isConnected) {
      this.socket.messages.next(json);
    }
    else {
      this.forceReconnect()
      let i = setInterval(() => {
        if (this.socket.isConnected) {
          this.socket.messages.next(json);
          clearInterval(i);
        }
      }, 100);
    }
  }

  monitorarExecao(cod: string) {
    if (this.listaMonitoramento.indexOf(cod) == -1) { this.listaMonitoramento.push(cod); return 'add'; }
    else { this.listaMonitoramento.splice(this.listaMonitoramento.indexOf(cod), 1); return 'remove'; }
  }

  verificarUrlWebSocket() {
    this.rest.obterUrlWebSocket().subscribe((data: any) => {
      if (data.status == 'success' && data.url) {
        this.session.setUrlWebSocket(data.url);
        this.reconectWebSocket(data.url);
      }
    });
  }

  toggleSideBar() {
    if (this.sideBar)
      this.comu.filter('hide-sidebar');
    else
      this.comu.filter('show-sidebar');
    this.sideBar = !this.sideBar
  }

  toggleMenu() {
    this.menu_visible = !this.menu_visible;
  }

  logoff() {
    if(this.socket.isConnected){
       this.socket.disconect();
    }   
    this.notificacao.complete();
    this.interacaoChamado.complete();
    this.protocoloChamado.complete();
    this.session.clear();
    this.unsubscribeSocket();
    this.router.navigate(['/login/login-form']);
  }


  allowChangeEmpresa() {
    return this.session.checkInGrupo([2, 3, 4]) && this.session.isMaster(true);
  }

  visibleDefaultEmpresa() {
    return this.session.isMaster() == false;
  }

  public ngDoCheck() {
    //resolve: ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after ...
    this.ref.detectChanges();
  }
  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigateByUrl(uri));
  }

  defaultEmpresa() {
    let key = {
      "tipo": this.sessao.tipo_empresa,
      "cnpj": this.sessao.cnpjEmpresa,
      'secretKey': this.sessao.secretKey,
      'razaoSocial': this.sessao.razaoSocial,
      'uuid': this.sessao.uuid_empresa,
      'idPlan': this.sessao.idPlan
    };
    this.session.setCurrentEmpresa(key);
    //window.location.reload();     
    this.redirectTo('/orcamento/todos/?' + new Date().getTime());
  }

  openSelectEmpresa() {
    const initialState = {};
    this.bsModalRef = this.modalService.show(SelecionarEmpresaPerfilComponent, { initialState, class: 'modal-dialog modal-md' });

  }

}